import HomePage from "../components/HomePage/home";
import Assessments from "../components/AARAssessments/assessments";
import Appointments from "../components/MTAAppointments/appointments";
import AppointmentForm from "../components/MTAAppointments/appointment-form";
import Error from "../components/Security/error";
import Callback from "../components/Security/callback";
import PageNotFound from "../components/Shared/page-not-found";

export const routes = [
  {
    name: "Home",
    path: "/",
    icon: "home",
    title: "Home",
    component: HomePage,
    onNavBar: false,
    onHomePage: false,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Assessments",
    path: "/aar-assessments",
    icon: "bus",
    title: "AAR Assessments",
    component: Assessments,
    onNavBar: true,
    onHomePage: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Appointments",
    path: "/mta-appointments",
    icon: "calendar-check",
    title: "IDEP Appointments",
    component: Appointments,
    onNavBar: true,
    onHomePage: true,
    meta: {
      requiresAuth: true,
      admin: true,
    },
  },
  {
    name: "NewAppointment",
    path: "/mta-appointment/new",
    icon: "calendar-plus",
    title: "New Appointment",
    component: AppointmentForm,
    onNavBar: true,
    onHomePage: false,
    props: true,
    meta: {
      requiresAuth: true,
      admin: true,
    },
  },
  {
    name: "EditAppointment",
    path: "/mta-appointment/edit",
    icon: "home",
    title: "Edit Appointment",
    component: AppointmentForm,
    onNavBar: false,
    onHomePage: false,
    props: true,
    meta: {
      requiresAuth: true,
      admin: true,
    },
    beforeEnter: (to, from, next) => {
      if (to.params.appointment) next();
      else next({ name: "Appointments" });
    },
  },
  {
    name: "Error",
    path: "/error",
    title: "Error",
    component: Error,
    onNavBar: false,
  },
  {
    name: "Callback",
    path: "/callback",
    title: "Callback",
    component: Callback,
    onNavBar: false,
    onHomePage: false,
  },
  {
    name: "PageNotFound",
    path: "*",
    title: "Page Not Found",
    component: PageNotFound,
    onNavBar: false,
  },
];
